import Form from "./Form";
import { useToast } from "@chakra-ui/react";
import {
  CreateDiscountCouponMutationVariables,
  useCreateDiscountCouponMutation,
} from "../../generated/graphql";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const [createMutation] = useCreateDiscountCouponMutation();
  const navigation = useNavigate();
  const toast = useToast();
  const handleCreate = async (data: CreateDiscountCouponMutationVariables) => {
    try {
      await createMutation({
        variables: {
          data: data.data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Kupon eklendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/discountcoupon");
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };
  return <Form handleCreate={handleCreate} actionType="CREATE" />;
};

export default Create;
